'use strict';

export default {
	CONTINUE: 'Continue',
	BACK: 'Back',
	CREATE: 'Create',
	UPDATE: 'Update'
};
